import { Outlet } from "react-router-dom";
import { useIsMobile } from "@/hooks/hooks/use-mobile";
import { useSearchHighlight } from "../search/use-search-highlight";
import { SettingsNavigationSidebar } from "./settings-navigation-sidebar";

export function SettingsLayout() {
  const isMobile = useIsMobile();

  // Pulse a ring around the field matching location.hash after a navigation
  // from the search palette. No-op when there is no hash.
  useSearchHighlight();

  if (isMobile) {
    return <Outlet />;
  }

  return (
    <div className="flex h-full bg-muted/30">
      {/* Desktop Navigation Sidebar - Fixed */}
      <div
        className="hidden lg:flex h-full w-70 flex-shrink-0 overflow-y-auto"
        // Cleared by the fixed global paused-bookings banner; the nav bars don't
        // push this column down since they're fixed too.
        style={{ paddingTop: "var(--paused-banner-height, 0px)" }}
      >
        <SettingsNavigationSidebar />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 min-w-0 flex flex-col">
        <Outlet />
      </div>
    </div>
  );
}
